export function removeAscent(str) {
  if (str === null || str === undefined) return str;
  return str.split(':')[0];
}
